import styled, { css } from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { FONT_STACK, STANDARD_TRANSITION, ZIndex } from '../../../styles/constants';
import { onMobile } from '../../../styles/onMobile';
import { propSwitch } from '../../../util/propSwitch';
import { IconCross } from '../../icons/IconCross';

export const PopUpView = styled.div<{ showing: boolean }>`
  ${FONT_STACK};
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: auto;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: ${ZIndex.POPUP};

  ${props =>
    props.showing &&
    css`
      pointer-events: auto;
    `}
`;

export const Overlay = styled.div.attrs({ 'data-testid': 'Overlay' })<{ darkOverlay: boolean }>`
  ${STANDARD_TRANSITION};
  background-color: ${propSwitch('darkOverlay', ThemeColours.black, 'transparent')};
  height: 100%;
  opacity: 0.45;
  position: fixed;
  right: 0;
  top: 0;

  width: 100%;

  &.enter {
    opacity: 0;
  }

  &.enter-active {
    opacity: 0.45;
  }

  &.exit {
    opacity: 0;
  }
`;

export const InnerPopUp = styled.div`
  ${STANDARD_TRANSITION};
  ${FONT_STACK};
  background-color: ${ThemeColours.white};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${ThemeColours.mono700};
  margin: 0;
  max-height: 480px;
  max-width: 456px;
  opacity: 1;
  overflow-y: auto;
  padding: 24px;
  text-align: center;
  transform: scale(1);
  z-index: ${ZIndex.POPUP};

  ${onMobile} {
    max-height: 80%;
    max-width: 100%;
    padding: 16px 16px 24px;
  }

  &.enter {
    opacity: 0;
    transform: scale(0.95);
  }

  &.enter-active {
    opacity: 1;
    transform: scale(1);
  }

  &.exit {
    opacity: 0;
    transform: scale(0.95);
  }
`;

export const CloseButton = styled(IconCross).attrs({ 'data-testid': 'CloseButton' })`
  border-radius: 32px;
  color: ${ThemeColours.black};
  cursor: pointer;
  height: 24px;
  padding: 8px;
  position: absolute;
  right: 8px;
  top: 8px;
  width: 24px;

  ${onMobile} {
    padding: 4px;
  }

  &:hover {
    background: ${ThemeColours.mono200};
  }
`;
